/* global $ */

import { Controller } from 'stimulus';
import loadSlick from '../helpers/loadSlick';

function getIcon(name) {
  return `
    <svg class='icon icon-${name} absolute-center' aria-hidden="true">
      <use xlink:href="#icon-${name}"></use>
    </svg>
  `;
}

function getButton(text, className, icon) {
  return `
    <button type="button" class="${className}">
      <span class="sr-only">${text}</span>
      ${getIcon(icon)}
    </button>
  `;
}

function getOptionsFromDataset(options) {
  const optionKeys = Object.keys(options);
  const config = {};

  optionKeys.forEach((option) => {
    const regex = /^slider/g;

    if (regex.test(option)) {
      let transformedOption = option.replace('slider', '');
      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      let value = options[option];

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      } else if (value.indexOf('[{') >= 0) {
        value = JSON.parse(value);
      }

      config[transformedOption] = value;
    }
  });

  return config;
}

class Slider extends Controller {
  connect() {
    loadSlick()
      .then(() => {
        this.createSlider();
      });
  }

  createSlider() {
    const options = this.element.dataset;

    let config = {
      prevArrow: getButton('Vorige', 'slider__arrow slick-prev', 'arrow-left'),
      nextArrow: getButton('Volgende', 'slider__arrow slick-next', 'arrow-right'),
    };

    if (typeof options !== 'undefined') {
      config = {
        ...config,
        ...getOptionsFromDataset(options),
      };
    }

    $(this.element).slick(config);
  }
}

Slider.targets = [
  'zoomButton',
];

export default Slider;
